import React from 'react';
import { 
  Rocket, 
  Building2, 
  CheckCircle2, 
  ArrowRight, 
  ShieldCheck,
  BarChart2,
  PieChart,
  LineChart
} from 'lucide-react';

export const InvestmentOpportunities = () => {
  const opportunities = [
    {
      icon: Rocket,
      title: "Venture Debt",
      description: "Early stage companies seeking growth capital",
      features: [
        "Complementary to equity funding",
        "Lower dilution for founders",
        "Structured returns with equity kicker"
      ],
      bgColor: "from-[#113262] to-[#1C52A0]"
    },
    {
      icon: Building2,
      title: "Private Credit Placement",
      description: "Mid-size companies seeking strategic financing",
      features: [
        "Private equity exits",
        "Acquisitions financing",
        "Business expansion",
        "Debt consolidation"
      ],
      bgColor: "from-[#955C0A] to-[#F49611]"
    }
  ];

  return (
    <div className="bg-white pt-16 relative">
      {/* Background Pattern */}
      <div className="absolute inset-0 bg-[#E8EEF6]/30">
        <div className="absolute inset-0" style={{
          backgroundImage: 'radial-gradient(#113262 1px, transparent 1px)',
          backgroundSize: '20px 20px',
          opacity: 0.1
        }} />
      </div>

      <div className="container relative z-10 max-w-6xl w-full mx-auto px-4 sm:px-6 lg:px-8 py-4 md:py-6 lg:py-8">
        <div className="max-w-3xl mx-auto text-center mb-16">
          <div className="w-12 h-0.5 bg-[#F49611] mx-auto mb-4" />
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-[#113262] mb-4">
            Investment Opportunities
          </h2>
          <p className="text-gray-600">
            Strategic private credit investments across different stages and needs
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8 max-w-5xl mx-auto">
          {opportunities.map((opp, index) => (
            <div key={index} className="relative group">
              {/* Card */}
              <div className={`bg-gradient-to-br ${opp.bgColor} rounded-lg p-8 text-white h-full`}>
                <div className="w-16 h-16 rounded-xl bg-white/10 flex items-center justify-center mb-6">
                  <opp.icon className="w-8 h-8 text-white" />
                </div>

                <h3 className="text-2xl font-bold mb-4">{opp.title}</h3>
                <p className="text-white/80 mb-6">{opp.description}</p>

                <div className="space-y-3">
                  {opp.features.map((feature, idx) => (
                    <div key={idx} className="flex items-center gap-3">
                      <CheckCircle2 className="w-5 h-5 text-[#F49611]" />
                      <span className="text-white/90">{feature}</span>
                    </div>
                  ))}
                </div>
              </div>  
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};




export default InvestmentOpportunities;